import React from "react";
import { resultTableConfigType } from "../../../common/types/search/results";
import { footnotesType, pagingType } from "../../../common/types/search/search";

interface SearchResultsFactoryProps {
	footnotes?: footnotesType;
	resultTableConfig: resultTableConfigType;
	paging: pagingType;
}

export const SearchResultsFactory = ({
	resultTableConfig,
	footnotes,
	paging,
}: SearchResultsFactoryProps) => {
	const {
		columns,
		resultRenderConfig,
		resultsDisplay: Results,
	} = resultTableConfig;

	return (
		<>
			<Results
				resultRenderConfig={resultRenderConfig(columns)}
				footnotes={footnotes}
				paging={paging}
			/>

			{/*Copy of table with all results for printing*/}
			<Results
				resultRenderConfig={resultRenderConfig(columns)}
				footnotes={footnotes}
				forPrint
				paging={paging}
			/>
		</>
	);
};
